import { useId } from 'react'

/**
 * Stand-in brand mark from the marketing mock (`assets/logo.svg`).
 * The repo has no production logo with real transparency: `favicon.webp`
 * bakes a checkerboard into the pixels, and the apple touch icon is the
 * Epic Stack starter mark. Swap this component when a real logo is ready.
 */
export function LogoMark({ className }: { className?: string }) {
	const gradientId = `rc-logo-${useId().replace(/:/g, '')}`
	return (
		<svg
			viewBox="0 0 64 64"
			className={className}
			aria-hidden="true"
			focusable="false"
		>
			<defs>
				<linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
					<stop offset="0" stopColor="#67e8f9" />
					<stop offset="1" stopColor="#2dd4bf" />
				</linearGradient>
			</defs>
			<rect width="64" height="64" rx="14" fill="#020617" />
			<path
				d="M12 32c6-9 15-13 24-13 5 0 9 2 12 5l6-6c1 5 1 9 0 14 1 5 1 9 0 14l-6-6c-3 3-7 5-12 5-9 0-18-4-24-13z"
				fill="none"
				stroke={`url(#${gradientId})`}
				strokeWidth="4"
				strokeLinejoin="round"
			/>
			<circle cx="22" cy="30" r="2.6" fill="#67e8f9" />
			<path
				d="M30 24c2 5 2 11 0 16"
				fill="none"
				stroke={`url(#${gradientId})`}
				strokeWidth="3"
				strokeLinecap="round"
			/>
		</svg>
	)
}
